import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import * as _ from 'lodash';

import { contentHeaders } from 'common/headers';
import { productComments } from './product-comments';
import {catchError} from 'rxjs/operators';


@Injectable()
export class CommentsService extends BaseHttpService {

  private rootUrl: string = 'comments';

  postComment(brandId: any, commentText: string, itemType: string, itemId?: any): Observable<any> {
    const body = JSON.stringify({ value: commentText });
    return this.http.post(
      `${Config.API}/${this.rootUrl}/${brandId}/${itemType}/${itemId || ''}`,
      body,
      {headers: contentHeaders}
    )

    .pipe(catchError(this.handleError.bind(this)));
  }

  putComment(brandId: any, commentId: any, commentText: string): Observable<any> {
    const body = JSON.stringify({ value: commentText });
    return this.http.put(
      `${Config.API}/${this.rootUrl}/${brandId}/${commentId}`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  deleteComment(brandId: any, commentId: any): Observable<any> {
    return this.http.delete(
      `${Config.API}/${this.rootUrl}/${brandId}/${commentId}`,
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  fetchItemComments(brandId: string, subjectId: any, subject: string, per: number = 10, page: number = 1): Observable<any> {
    return this.http.get(
      `${Config.API}/${this.rootUrl}/${brandId}/${subject}/${subjectId || ''}` +
      `?itemsPerPage=${per}` +
      `&page=${page}`
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  fetchFeedComments(brandId: string, itemsPerPage: number = 10, page: number = 1): Observable<any> {
    return this.http.get(
      `${Config.API}/${this.rootUrl}/${brandId}` +
      `?itemsPerPage=${itemsPerPage}` +
      `&page=${page}`
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  markAsRead(brandId: any, commentIds: Array<string>): Observable<any> {
    const body = JSON.stringify({ commentIds });
    return this.http.put(
      `${Config.API}/${this.rootUrl}/${brandId}/mark-as-read`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  getTotalUnreadCount(brandId: any): Observable<any> {
    return this.http.get(
      `${Config.API}/${this.rootUrl}/${brandId}/unread-count`
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  getUnreadCount(brandId: any, subject: string, subjectId?: any): Observable<any> {
    return this.http.get(
      `${Config.API}/${this.rootUrl}/${brandId}/unread-count/${subject}/${subjectId || ''}`
    )

        .pipe(catchError(this.handleError.bind(this)));
  }
}
